import { PartyActions } from './actions'
import { PartyGetters } from './getters'
import { PartyMutations } from './mutations'
import { PartyState } from './state'

export const PARTY_NAMESPACE = 'party'

export const Party = {
  namespaced: true,
  state: PartyState,
  actions: PartyActions,
  mutations: PartyMutations,
  getters: PartyGetters,
}
